export enum ContractHandlerType {
    openZeppelin = 'openZeppelin'
  }
  
export enum DeploymentDataType {
  regular = 'regular',
  proxy = 'proxy'
}